angular.module('tgaAdmin').directive('delayEnable', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'AC',
      link(scope, el, attrs) {
        el[0].disabled = true;
        $timeout(() => {
          el[0].disabled = false;
        }, attrs.delay || 5000);
      },
    };
  },
]);
